import { render, staticRenderFns } from "./Complete.vue?vue&type=template&id=74a40b9e&scoped=true"
import script from "./Complete.vue?vue&type=script&lang=js"
export * from "./Complete.vue?vue&type=script&lang=js"
import style0 from "./Complete.vue?vue&type=style&index=0&id=74a40b9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a40b9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a40b9e')) {
      api.createRecord('74a40b9e', component.options)
    } else {
      api.reload('74a40b9e', component.options)
    }
    module.hot.accept("./Complete.vue?vue&type=template&id=74a40b9e&scoped=true", function () {
      api.rerender('74a40b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InventionApply/Complete.vue"
export default component.exports